"use client";

import { Avatar, Badge, Skeleton, Input, Image, message, Button } from 'antd';
import { useState, useEffect } from 'react';
import { chatMsgList, assistantChat, askpaulChat, welcome, chatList } from "@/service/message/index";
import { markRead } from "@/service/common/index";
import Link from "next/link";
import useMobileDetect from "@/hooks/useMobileDetect";
import PercentageChart from '@/app/event/[eventName]/components/PercentageChart';

import btn_send_icon_png from "@/app/assets/message/btn_send.png"
import ai_default_icon_png from "@/app/assets/mine/ai_default@2x.png"
import user_default_icon_png from "@/app/assets/mine/user_default@2x.png"

import { UserOutlined, SyncOutlined } from '@ant-design/icons';
import userInfoStore from "@/store/userInfoStore";
import type { GetProps } from 'antd';
import { extractContent } from "@/utils/tools";
import "./list.css";

type SearchProps = GetProps<typeof Input.Search>;

const { Search } = Input;

export type ChatListProps = {
  chatId?: string,
  relationId?: string,
  relationType?: string,
}

export type MarketType = {
  eventId: number,
  marketId: number,
  image: string,
  question: string,
  outcome1Probability: number,
  parentTag: {
    id: number,
    label: string
  },
  childTag: {
    id: number,
    label: string
  },
  eventLink: string
}

type chatData = {
  messages: {
    content: string,
    constentType?: string,
    constentData?: {
      title: string,
      data: MarketType[],
      trends?: MarketType[],
      outcomePrice1: number,
      outcomePrice2: number,
      text?: string,
      buttons?: {
        button_type: string,
        text: string
        params: {
          link: string // "askpaul://event?id=367&openBet=1"
        }
      }[]
    },
    createTime: string,
    id: string,
    role: string,
    sendUserId: string,
    timestamp: number
  }[],
  userInfo: {
    [key: string]: { avatar: string, name: string }
  }
}
export const ChatMegList: React.FC<ChatListProps> = ({ chatId, relationId, relationType, ...props }) => {
  const [chat, setChat] = useState<chatData>();
  const { userInfo } = userInfoStore();
  const [welcomeArr, setWelcomeArr] = useState<string[]>([])
  const [inputStr, setInputStr] = useState<string>("")
  const [isLoading, setIsLoading] = useState(false)
  const [newChatId, setNewChatId] = useState<string>("")
  const isMobile = useMobileDetect();

  const localStorageName = "chatId" + chatId + "prompt"

  useEffect(() => {
    const eventName = globalThis.localStorage.getItem("eventName")
    if (chatId) {
      getMsgList(chatId)
      markRead({ "chat_id": chatId })
      if (eventName) {
        globalThis.localStorage.setItem("eventName", "")
        setInputStr(eventName)
        setIsLoading(true)
        assistantChat({
          chat_id: chatId,
          message: eventName
        }).then(res => {
          const content = res as unknown as string
          setPromptArr(chatId, content)
          getMsgList(chatId)
        })
      }
    } else {
      if (eventName) {
        globalThis.localStorage.setItem("eventName", "")
        setIsLoading(true)
        setInputStr(eventName)
        askpaulChat({
          message: eventName
        }).then(res => {
          const content = res as unknown as string
          getMsgList_1(content, eventName)
          setIsLoading(false)
          setInputStr("")
          chatList<{ chatName: string, chatId: string }[]>().then(res => {
            if (res.code === 0) {
              res.data.some(item => {
                if (item.chatName === eventName) {
                  setNewChatId(item.chatId)
                  setPromptArr(item.chatId, content)
                  return true
                }
                return false
              })
            }
          })
        })
      }
    }
  }, []);

  const setPromptArr = (key: string, content: string) => {
    const localStorageName = "chatId" + key + "prompt"
    const arr = extractWithRegex(content)
    localStorage.setItem(localStorageName, JSON.stringify(arr))
    setWelcomeArr(arr)
  }

  const getMsgList_1 = (res: string, eventName?: string) => {
    let content = res
    content = getText(content)

    if (chat) {
      chat.messages.push({
        content,
        sendUserId: "system",
        role: "assistant",
        createTime: "",
        timestamp: Date.now(),
        id: '-1',
      })
      setChat({ ...chat })
    } else {
      const data = {
        messages: [
          {
            content: eventName || "",
            sendUserId: userInfo?.userId,
            role: "user",
            createTime: "",
            timestamp: Date.now(),
            id: Math.random() + '',
          },
          {
            content,
            sendUserId: "system",
            role: "assistant",
            createTime: "",
            timestamp: Date.now(),
            id: '-1',
          }
        ],
        userInfo: {},
      }
      setChat({ ...data })
    }
  }

  useEffect(() => {
    goBottom()
  }, [chat, welcomeArr])

  const getMsgList = (chatId: string) => {
    chatMsgList<chatData>(chatId).then(res => {
      if (res.code === 0) {
        const data = res.data
        setChat(data)
        if (data?.messages.length) {
          const welcomeArrStr = localStorage.getItem(localStorageName)
          if (welcomeArrStr) {
            const arr = JSON.parse(welcomeArrStr)
            setWelcomeArr(arr)
          }
        } else {
          welcome<string>({
            chat_id: chatId,
            relation_id: relationId,
            relation_type: relationType,
          }).then(res => {
            const arr = extractWithRegex(res as unknown as string)
            let content = res as unknown as string
            if (!data?.messages.length) {
              content = getText(content)
              data?.messages.push({
                content,
                sendUserId: "system",
                role: "assistant",
                createTime: "",
                timestamp: Date.now(),
                id: '-1',
              })
              setChat(data)
            }
            setWelcomeArr(arr)
          })
        }
        setIsLoading(false)
        setInputStr("")
      }
    })
  }

  const goBottom = () => {
    setTimeout(() => {
      if (isMobile) {
        window.document.body.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })
      } else {
        window.document.querySelector("#chat-list")?.scrollTo({
          top: 9999,
          behavior: 'smooth'
        })
      }

    }, 200)
  };

  // 使用正则表达式提取
  const extractWithRegex = (text: string) => {
    const pattern = /\*#prompt-start#\*(.*?)\*#prompt-end#\*/g;
    const results = [];
    let match;

    while ((match = pattern.exec(text)) !== null) {
      if (match[1]) {
        results.push(match[1].trim());
      }
    }

    return results;
  }

  // 获取文本
  const getText = (content: string) => {
    const startMarker = "\*#text-start#\*";
    const endMarker = "\*#text-end#\*";
    console.log("content: ", content)

    const idx = content.indexOf(startMarker)
    if (idx > -1) {
      const startIndex = content.indexOf(startMarker) + startMarker.length;
      const endIndex = content.indexOf(endMarker);
      content = content.slice(startIndex, endIndex);
    } else {
      const res = extractContent(content)
      if (res.isCard) {
        console.log("card: ", res.txt)
        content = JSON.parse(res.txt)
      } else {
        content = res.txt
      }
    }
    return content
  }

  // 提交
  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    // console.log(info?.source, value);
    if (isLoading) {
      return
    }
    setIsLoading(true)
    setWelcomeArr([])
    setInputStr(value)
    chat?.messages.push({
      content: value,
      sendUserId: userInfo?.userId,
      role: "user",
      createTime: "",
      timestamp: Date.now(),
      id: Math.random() + '',
    })
    if (chat) {
      setChat({ ...chat })
    }

    if (!chatId) {
      assistantChat({ message: value, chat_id: newChatId }).then(res1 => {
        const content = res1 as unknown as string
        getMsgList_1(content)
        setInputStr("")
        setIsLoading(false)

        setPromptArr(newChatId, content)
      })
      return
    }
    assistantChat({ message: value, chat_id: chatId, relation_type: relationType, relation_id: relationId }).then(res1 => {
      chatMsgList<chatData>(chatId).then(res => {
        if (res.code === 0) {
          const data = res.data
          setChat(data)
        }
        const content = res1 as unknown as string
        setPromptArr(newChatId, content)
      })
      setInputStr("")
      setIsLoading(false)
    })
  }

  const itemToChat = (msg: string) => {
    onSearch(msg)
    setWelcomeArr([])
  }

  // 渲染列表
  const renderList = (list: MarketType[]) => {
    return list.map((item: MarketType, index: number) => (
      <Link href={item.eventLink} className="mx-20 py-14 flex items-center "
        style={index === list.length - 1 ? {} : { borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}
        key={index}
      >
        <div className='basis-44'><Image src={item.image} className="w-44 h-44 rounded-md object-cover" alt={item.question} width={44} height={44} /></div>
        <div className='ml-10 '>
          <div className="text-white text-15 leading-20">{item.question}</div>
          <div className="flex items-center text-bravve-sub-500 text-13 leading-20">
            <span>{item.parentTag?.label}</span>
            {item.childTag ? <span className="text-18 h-12 leading-10 mx-8">&rsaquo;</span> : ''}
            <span>{item.childTag?.label}</span>
          </div>
        </div>
        <div className="text-bravve-100 text-15 font-bold ml-auto">
          {item.outcome1Probability}%
        </div>
      </Link>
    ))
  }

  return (
    <div className="cardList">
      {
        !chat ?
          <div className='px-15 pt-15'>
            <div className='cardItem_race pt-20'>
              <Skeleton active />
            </div>
            <div className='cardItem_race pt-20'>
              <Skeleton active />
            </div>
            <div className='cardItem_race pt-20'>
              <Skeleton active />
            </div>
          </div>
          :
          chat.messages.map((item, index) => {

            if (item.role === "assistant") {
              const res = extractContent(item.content)
              if (res.isCard) {
                const data = JSON.parse(res.txt)
                item.constentType = data.type
                item.constentData = data.config
              } else {
                item.content = getText(item.content)
              }
            }

            return (
              <div key={index}>
                {
                  item.role === 'assistant' ?
                    <>
                      <div className="flex px-15 pt-15" >
                        <Avatar shape="square" size="large" src={chat.userInfo[item.sendUserId]?.avatar || ai_default_icon_png.src} alt={chat.userInfo[item.sendUserId]?.name || "Paul"}
                          style={{ width: '3rem', height: '3rem', marginRight: '1rem', borderRadius: '50%', flex: "0 0 3rem" }} />
                        <div
                          className='px-15 py-12 text-14 leading-24 text-white flex-1'
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "0 2rem 2rem 2rem",
                            whiteSpace: "pre-line"
                          }}
                        >
                          {
                            item.constentType === "market_list" ?
                              <div className="market_list">
                                <h5>{item.constentData?.title}</h5>
                                {
                                  renderList(item.constentData?.data || [])
                                }
                              </div>
                              :
                              item.constentType === "market_price_trend" ?
                                <div className="market_list">
                                  <h5>{item.constentData?.title}</h5>
                                  {

                                    item.constentData?.trends ?
                                      // @ts-ignore
                                      <PercentageChart data={item.constentData?.trends} yesP={item.constentData?.outcomePrice1 || 0} noP={item.constentData?.outcomePrice2 || 0} />
                                      :
                                      null
                                  }
                                </div>
                                : item.constentType === 'text_with_buttons' ?
                                  <div className="market_list">
                                    <div>{item.constentData?.text}</div>
                                    {
                                      item.constentData?.buttons?.map((btn: { params: { link: string }, text: string }, index: number) => (
                                        <Link
                                          key={index}
                                          className='w-full h-44 rounded-sm flex items-center justify-center leading-20 text-17 font-bold text-bravve-300 mt-10'
                                          style={{ background: '#FFED41' }}
                                          href={btn.params.link.replace("askpaul://event?", `https://askpaul.ai/event/${btn.text}?e`)}
                                        >
                                          {btn.text}
                                        </Link>
                                      ))
                                    }
                                  </div>
                                  :
                                  item.content
                          }
                        </div>
                      </div>
                      {/* {
                        item.createTime && <div className='text-bravve-sub-500 text-center mt-18 mb-18'>{item.createTime}</div>
                      } */}
                    </>
                    :
                    null
                }
                {
                  item.role === 'user' ?
                    <>
                      <div className="flex px-15 pt-15 flex-row-reverse" >
                        <Avatar shape="square" size="large" alt={chat.userInfo[item.sendUserId]?.name} src={user_default_icon_png.src}
                          style={{
                            verticalAlign: 'middle', width: '3rem', height: '3rem', marginLeft: '1rem',
                            borderRadius: '50%', flex: "0 0 3rem"
                          }} />
                        <div
                          className='px-15 py-12 text-14 leading-24 text-black'
                          style={{
                            background: "rgba(0, 242, 252, 0.75)",
                            borderRadius: "20px 0 20px 20px"
                          }}
                        >
                          {item.content}
                        </div>
                      </div>
                      {
                        item.createTime && <div className='text-bravve-sub-500 text-center mt-18 mb-18'>{item.createTime}</div>
                      }
                    </>
                    :
                    null
                }
              </div>
            )
          })
      }

      {
        welcomeArr.map((item, idx) => <div key={idx} onClick={() => itemToChat(item)}
          className="text-base text-bravve-sub-500 px-15 py-8 rounded-16 ml-55 mr-15 my-10 cursor-pointer"
          style={{ border: '1px solid rgba(255, 255, 255, 0.2)' }}>{item}</div>)
      }

      <div className='h-84'></div>
      <div className='p-10 fixed bottom-0 w-full overflow-hidden'
        style={{ maxWidth: isMobile ? "var(--max-width)" : "800px", boxShadow: "0 0 1rem 0 rgba(0, 0, 0, 0.2)", borderRadius: '2.2rem', background: "rgba(32, 28, 51, 1.0)" }}
      >
        <div
          className='h-44 overflow-hidden chatSendWrap'
          style={{ borderRadius: '2.2rem', background: "rgba(255, 255, 255, 0.2)" }}>
          <Search
            value={inputStr}
            placeholder="Anything to help?"
            onSearch={onSearch}
            onChange={(e) => setInputStr(e.target.value)}
            enterButton={isLoading ? <SyncOutlined spin style={{ width: '4.4trm', height: '4.4rem', margin: '0 1rem' }} /> :
              <Image src={btn_send_icon_png.src} alt="send" className="w-44 h-44" width={44} height={44} preview={false} />} />
        </div>
      </div>
    </div>
  )
}
